import { useEffect, useState } from "react";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Products from "@/components/Products";
import Manifesto from "@/components/Manifesto";
import Stats from "@/components/Stats";
import Footer from "@/components/Footer";
import QuoteForm from "@/components/QuoteForm";

export default function Home() {
  const [quoteOpen, setQuoteOpen] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -80 });
        }
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  const openQuote = () => setQuoteOpen(true);

  return (
    <div className="min-h-screen bg-[#0B1320]">
      <Navbar onQuote={openQuote} />
      <main>
        <Hero onQuote={openQuote} />
        <Marquee />
        <Services />
        <Products />
        <Manifesto />
        <Stats />
      </main>
      <Footer onQuote={openQuote} />
      <QuoteForm open={quoteOpen} onClose={() => setQuoteOpen(false)} />
    </div>
  );
}
